import React, { useEffect, useState } from "react";
import { Modal, Spinner } from "react-bootstrap";
import { useSelector, shallowEqual } from "react-redux";
import axios from "axios";
import CallDetailsTabs from "./CallDetailsTabs";

const CallDetailsModal = ({ show, onHide, leadId }) => {
  const { cdnURL, adminBaseURL } = useSelector(
    (state) => state.environnment.environmentLists,
    shallowEqual
  );

  const [isLoading, setIsLoading] = useState(false);
  const [coldLead, setColdLead] = useState({});
  const [callItems, setCallItems] = useState([]);

  useEffect(() => {
    if (!show || !leadId) return;

    let mounted = true;
    (async () => {
      try {
        setIsLoading(true);
        const { data } = await axios({
          method: "GET",
          url: `${process.env.REACT_APP_HOST}${adminBaseURL}/candidateMaster/getCallDetails/${leadId}`,
          headers: { "Content-Type": "application/json" },
        });

        if (!mounted) return;
        if (data && (data.status === 200 || data.code === 200) && data.data) {
          const payload = data.data || {};
          console.log("payload==========>", payload);
          setColdLead(payload.lead || payload.coldLead || payload.cold_lead || payload);
          const items = payload.call_ai || payload.callAi || payload.callRecords || [];
          setCallItems(Array.isArray(items) ? items : []);
        } else {
          setColdLead({});
          setCallItems([]);
        }
      } catch (error) {
        if (!mounted) return;
        setColdLead({});
        setCallItems([]);
      } finally {
        if (mounted) setIsLoading(false);
      }
    })();

    return () => {
      mounted = false;
    };
  }, [show, leadId, adminBaseURL]);

  return (
    <>
      <Modal
        show={show}
        onHide={onHide}
        fullscreen
        scrollable
        centered
        dialogClassName="call-details-dialog-95"
        contentClassName="h-100"
      >
        <Modal.Header className="d-flex justify-content-between align-items-center">
          <Modal.Title className="mb-0">AI Agent Call Review</Modal.Title>
          <button
            type="button"
            className="btn btn-link p-0"
            onClick={onHide}
            aria-label="Close"
            style={{ fontSize: 24, lineHeight: 1, color: "#6b7280", textDecoration: "none" }}
          >
            ×
          </button>
        </Modal.Header>
        <Modal.Body
          style={{
            background: "#f8fafc",
            display: "flex",
            flexDirection: "column",
            gap: 16,
            minHeight: "80vh", // keep full height to prevent flicker while loading
          }}
        >
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
              <Spinner animation="border" />
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 16, minHeight: 0 }}>
              <div
                style={{
                  background: "#ffffff",
                  borderRadius: 12,
                  border: "1px solid #e5e7eb",
                  padding: "16px 20px",
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))",
                  gap: 12,
                }}
              >
                <div>
                  <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Lead Name</div>
                  <div style={{ fontWeight: 600, color: "#111827" }}>{coldLead?.name || "-"}</div>
                </div>
                <div>
                  <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Email</div>
                  <div style={{ fontWeight: 600, color: "#111827" }}>{coldLead?.email || "--"}</div>
                </div>
                <div>
                  <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Mobile</div>
                  <div style={{ fontWeight: 600, color: "#111827" }}>{coldLead?.contactNumber || "-"}</div>
                </div>
                {coldLead?.countryName && (
                  <div>
                    <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Country</div>
                    <div style={{ fontWeight: 600, color: "#111827" }}>{coldLead?.countryName}</div>
                  </div>
                )}
                {coldLead?.currentCountryTime && (
                  <div>
                    <div style={{ fontSize: 12, color: "#6b7280", marginBottom: 4 }}>Current Time</div>
                    <div style={{ fontWeight: 600, color: "#111827" }}>{coldLead?.currentCountryTime}</div>
                  </div>
                )}
              </div>

              <div
                style={{
                  background: "#ffffff",
                  borderRadius: 12,
                  border: "1px solid #e5e7eb",
                  flex: 1,
                  minHeight: 0,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <CallDetailsTabs
                  callItems={callItems}
                  cdnURL={cdnURL}
                  emptyMessage="No AI call records available for this cold lead."
                />
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>
      <style>{`
        .call-details-dialog-95 {
          max-width: 98% !important;
          width: 98%;
        }
      `}</style>
    </>
  );
};

export default CallDetailsModal;

